import { Link } from 'react-router-dom';
import { usePractices, useTogglePracticeActive } from '../lib/queries';
import Spinner from '../components/Spinner';

export default function Practices() {
  const { data, isLoading, error } = usePractices();
  const toggle = useTogglePracticeActive();

  if (isLoading) return <Spinner />;
  if (error)
    return (
      <div className="alert alert-danger">
        Erro: {String((error as Error).message)}
      </div>
    );

  const rows = data ?? [];

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0">Consultórios</h1>
        <Link to="/practices/new" className="btn btn-sm btn-bb">
          <i className="bi bi-plus-lg me-1" /> Novo consultório
        </Link>
      </div>

      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Slug</th>
                <th>Nome</th>
                <th>Pediatra</th>
                <th>Plano</th>
                <th>Limites</th>
                <th>Status</th>
                <th>Link de convite</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => {
                const inviteUrl = `https://bebecare.com.br/c/${p.slug}`;
                return (
                  <tr key={p.id}>
                    <td>
                      <code className="small">{p.slug}</code>
                    </td>
                    <td>
                      <div className="fw-semibold small">{p.display_name}</div>
                      {p.tagline && (
                        <div
                          className="text-muted"
                          style={{ fontSize: '0.75rem' }}
                        >
                          {p.tagline}
                        </div>
                      )}
                    </td>
                    <td className="small">
                      {p.doctor_name ?? '—'}
                      {p.crm && (
                        <div
                          className="text-muted"
                          style={{ fontSize: '0.72rem' }}
                        >
                          {p.crm}
                        </div>
                      )}
                    </td>
                    <td>
                      <span className="badge bg-light text-dark border">
                        {p.plan}
                      </span>
                    </td>
                    <td className="small text-muted">
                      {p.max_patients} fam · {p.max_doctors} méd
                    </td>
                    <td>
                      <div className="form-check form-switch m-0">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={p.active}
                          onChange={(e) =>
                            toggle.mutate({
                              id: p.id,
                              active: e.target.checked,
                            })
                          }
                        />
                      </div>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-link p-0 small text-decoration-none"
                        onClick={async () => {
                          await navigator.clipboard.writeText(inviteUrl);
                        }}
                        title="Copiar link"
                      >
                        <i className="bi bi-clipboard me-1" />
                        copiar
                      </button>
                    </td>
                    <td className="text-end">
                      <Link
                        to={`/practices/${p.slug}`}
                        className="btn btn-sm btn-outline-secondary"
                      >
                        Editar
                      </Link>
                    </td>
                  </tr>
                );
              })}
              {rows.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center text-muted py-4">
                    Nenhum consultório cadastrado ainda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
